import { render, staticRenderFns } from "./DialogForwardCase.vue?vue&type=template&id=6394f122&scoped=true&"
import script from "./DialogForwardCase.vue?vue&type=script&lang=ts&"
export * from "./DialogForwardCase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394f122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
